import "./Contact.css";
import {
  InstagramIcon,
  LinkedInIcon,
  WhatsAppIcon,
} from "../../../utils/constants";
import { InlineWidget } from "react-calendly";
import { useLang } from "../../../utils/i18n";

const Contact = () => {
  const lang = useLang();
  const copy = {
    en: {
      heading: "Get in touch directly",
      intro:
        "If you have any questions or are interested in our services, feel free to call us, send a WhatsApp message, or email us. We will get back to you as soon as possible.",
      phone: "Phone",
      email: "Email",
      secondaryHeading: "We provide direct, personalised guidance",
      secondaryText:
        "Choose a convenient time in the calendar below and we will meet you in an initial online session.\n\nIt will be a pleasure to speak with you.",
      calendarKicker: "Book a strategy session",
      country: "Brazil",
    },
    pt: {
      heading: "Entre em contato diretamente",
      intro:
        "Se você tiver dúvidas ou interesse em nossos serviços, fique à vontade para nos ligar, enviar uma mensagem por WhatsApp ou nos escrever por e-mail. Retornaremos o mais breve possível.",
      phone: "Telefone",
      email: "E-mail",
      secondaryHeading: "Oferecemos orientação direta e personalizada",
      secondaryText:
        "Escolha um horário adequado no calendário abaixo e nós o atenderemos em uma reunião inicial online.\n\nSerá um prazer conversar com você!",
      calendarKicker: "Agende uma sessão estratégica",
      country: "Brasil",
    },
  };

  return (
    <section className="contact-page">
      <div className="contact-top">
        <article className="contact-panel contact-primary">
          <h1 className="main-heading">{copy[lang].heading}</h1>
          <p className="contact-intro">{copy[lang].intro}</p>

          <div className="contact-meta">
            <div className="contact-address">
              <p className="contact-address-text">
                Monetique Estratégia e Gestão Financeira Ltda.
                <br />
                Avenida Brigadeiro Faria Lima, 1811
                <br />
                Sala 1119
                <br />
                São Paulo, SP, {copy[lang].country}
              </p>
              <div className="social-icons-footer contact-socials">
                <div>
                  <LinkedInIcon />
                </div>
                <div>
                  <InstagramIcon />
                </div>
                <div>
                  <WhatsAppIcon />
                </div>
              </div>
            </div>
            <div className="contact-direct">
              <p className="contact-detail-label">{copy[lang].phone}</p>
              <a className="contact-link" href="tel:+5511944794757">+55 11 94479-4757</a>
              <p className="contact-detail-label contact-email-label">{copy[lang].email}</p>
              <a className="contact-link" href="mailto:info@monetiquepro.com">info@monetiquepro.com</a>
            </div>
          </div>
        </article>

        <article className="contact-panel contact-secondary">
          <h2 className="main-heading">{copy[lang].secondaryHeading}</h2>
          <p className="contact-secondary-text">
            {copy[lang].secondaryText.split("\n").map((line, index) => (
              <span key={index} className="contact-secondary-line">
                {line}
                <br />
              </span>
            ))}
          </p>
        </article>
      </div>

      <section className="contact-calendar-panel">
        <p className="contact-calendar-kicker">{copy[lang].calendarKicker}</p>
        <div className="contact-calendar-wrap">
          <InlineWidget url="https://calendly.com/luciana-monetiquepro/financial-strategy-meeting-monetique?month=2025-11" />
        </div>
      </section>
    </section>
  );
};

export default Contact;
